module.exports = __webpack_public_path__ + "e06d47468baf2b7e615649723f416fa8.png";